module.exports = __webpack_public_path__ + "img/Flag_of_Swaziland_1894.ca9048ce.svg";